import { atomWithStorage } from "jotai/utils";
import { useAtom, useSetAtom } from "jotai";

const preferredEngineAtom = atomWithStorage<"use-sound" | "howler">(
  "preferredEngine",
  "use-sound"
);

const usePreferredSoundEngine = () => {
  const atom = useAtom(preferredEngineAtom);
  return atom;
};

export const useSetPreferredSoundEngine = () => useSetAtom(preferredEngineAtom);

export default usePreferredSoundEngine;
